import {
  selectJBPSettings,
  selectKiBusinessPriorities,
} from 'legacy/lut/features/partner360/jbpSettings'
import { createSelector } from 'reselect'

import { DEFAULT_CURRENCY, getCockpitInitiativesPlanQualitySummary } from '../../lib'

import { selectCockpitCurrency } from './selectCockpitCurrency'
import { selectCockpitGeoMappingItems } from './selectCockpitGeoMappingItems'
import { selectCockpitMetric } from './selectCockpitMetric'
import { selectCockpitOfferingPresentation } from './selectCockpitOfferingPresentation'
import { selectCockpitPeriods } from './selectCockpitPeriods'
import { selectCockpitPlanningPeriod } from './selectCockpitPlanningPeriod'
import { selectEffectiveCockpitActualsSync } from './selectEffectiveCockpitActualsSync'
import { selectVisibleCockpitFinSobRows } from './selectVisibleCockpitFinSobRows'
import { selectVisibleCockpitKeyInitiatives } from './selectVisibleCockpitKeyInitiatives'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

export const selectCockpitInitiativesPlanQualityByOffering = createSelector(
  [
    selectVisibleCockpitKeyInitiatives,
    selectVisibleCockpitFinSobRows,
    selectVisibleCockpitPartnerData,
    selectCockpitGeoMappingItems,
    selectKiBusinessPriorities,
    selectJBPSettings,
    selectCockpitOfferingPresentation,
    selectEffectiveCockpitActualsSync,
    selectCockpitMetric,
    selectCockpitCurrency,
    selectCockpitPeriods,
    selectCockpitPlanningPeriod,
  ],
  (
    initiatives,
    rows,
    partners,
    geoMappingItems,
    businessPriorities,
    { keyObjectives },
    offeringPresentation,
    { fYear, currentFQuarter, fQuarterActualsPercentage },
    selectedMetric,
    selectedCurrency,
    selectedPeriods,
    planningPeriod
  ) =>
    getCockpitInitiativesPlanQualitySummary({
      initiatives,
      rows,
      partners,
      geoMappingItems,
      businessPriorities,
      keyObjectives,
      offeringPresentation,
      fYear,
      currentFQuarter,
      fQuarterActualsPercentage,
      selectedMetric,
      selectedCurrency,
      selectedPeriods,
      planningPeriod,
      isLocalCurrency: selectedCurrency !== DEFAULT_CURRENCY,
    })
)
